<template>
  <div class="number-unit align-items-center ml-sm mr-sm">
    <el-input-number :value="value" v-bind="$attrs" v-on="$listeners" />
    <i class="split"></i>
    <div class="unit-box flex-center">{{ unit }}</div>
  </div>
</template>

<script>
export default {
  name: "FNumberUnit",
  inheritAttrs: false,
  // 具体属性参照el-input-number
  props: {
    /**
     * 单位
     * @type {String}
     */
    unit: {
      type: String,
      default: ''
    },
    /**
     * 值（v-model绑定）
     * @type {String | Number}
     */
    value: {
      type: [String, Number],
      default: null
    },
  },
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.number-unit {
  display: inline-flex;
  width: 100px;
  height: 36px;
  border: 1px solid #EEF0F5;
  border-radius: 5px;
  line-height: 1;
  transition: border 0.2s;
  color: #101010;
  background-color: #fff;

  &:focus-within {
    border-color: #07c160;
  }

  .el-input-number {
    width: 50px;
    height: 100%;
    border: none;
    outline: none;
    text-align: center;
    font-size: inherit;

    /deep/ .el-input-number__decrease,
    /deep/ .el-input-number__increase {
      display: none;

    }

    /deep/ .el-input {
      height: 100%;

      .el-input__inner {
        padding: 0;
        height: 100%;
        border: none;
        line-height: 1;
      }
    }
  }

  .split {
    display: inline-block;
    width: 1px;
    height: 28px;
    background: #EEF0F5;
  }

  .unit-box {
    flex: 1;
    height: 100%;
  }
}
</style>
